import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ApproachSection from './components/ApproachSection';
import GallerySection from './components/GallerySection';
import ServicesSection from './components/ServicesSection';
import FAQSection from './components/FAQSection';
import DrawingInsightSection from './components/DrawingInsightSection';
import TestimonialsSection from './components/TestimonialsSection';
import EducationSection from './components/EducationSection';
import Footer from '@/components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <section id="hero" className="snap-section-auto">
        <HeroSection />
      </section>
      
      <section id="about" className="snap-section-auto">
        <AboutSection />
      </section>
      
      <section id="art-therapy" className="snap-section-auto">
        <ApproachSection />
      </section>
      
      <section id="gallery" className="snap-section-auto">
        <GallerySection mode="preview" />
      </section>
      
      <section id="testimonials" className="snap-section-auto">
        <TestimonialsSection variant="text" />
      </section>
      
      <section id="services-pricing" className="snap-section-auto">
        <ServicesSection />
      </section>
      
      <section id="faq" className="snap-section-auto">
        <FAQSection />
      </section>
      
      <section id="drawing-insight" className="snap-section-auto">
        <DrawingInsightSection />
      </section>
      
      <section id="education" className="snap-section-auto">
        <EducationSection mode="preview" />
      </section>

      <Footer />
    </div>
  );
}